import React, { useEffect, useState } from "react";
import Sidebar from "../../component/home/sidebar";
import DataTable from "react-data-table-component";
import axios from "axios";
import SearchForm from "../../component/search-form";

function Invoice() {
  // Dummy Data
  const dummy = [
    {
      invoice_no: "INV3462961",
      period: "14th MAR 23 - 13th APR 23",
      amount: "$ 19.99",
      status: "PAYMENT PENDING",
    },
    {
      invoice_no: "INV3462962",
      period: "15th MAR 23 - 16th APR 23",
      amount: "$ 29.99",
      status: "PAYMENT PENDING",
    },
    {
      invoice_no: "INV3462963",
      period: "17th MAR 23 - 18th APR 23",
      amount: "$ 39.99",
      status: "PAYMENT PROCESSING",
    },
    {
      invoice_no: "INV3462964",
      period: "19th MAR 23 - 20th APR 23",
      amount: "$ 49.99",
      status: "PAYMENT PROCESSING",
    },
    {
      invoice_no: "INV3462965",
      period: "21th MAR 23 - 22th APR 23",
      amount: "$ 59.99",
      status: "PAYMENT PROCESSING",
    },
    {
      invoice_no: "INV3462966",
      period: "22th MAR 23 - 23th APR 23",
      amount: "$ 69.99",
      status: "PAYMENT DONE",
    },
    {
      invoice_no: "INV3462967",
      period: "24th MAR 23 - 25th APR 23",
      amount: "$ 79.99",
      status: "PAYMENT DONE",
    },
    {
      invoice_no: "INV3462968",
      period: "25th MAR 23 - 26th APR 23",
      amount: "$ 89.99",
      status: "PAYMENT DONE",
    },
    {
      invoice_no: "INV3462969",
      period: "27th MAR 23 - 28th APR 23",
      amount: "$ 99.99",
      status: "PAYMENT DONE",
    },
  ];

  // Creating state for invoice data table.
  const [result, setResult] = useState(dummy);
  const [tableData, setTableData] = useState();
  const [searchText, setSearchText] = useState();
  const [filterData, setFilterData] = useState();
  const [loader, setLoader] = useState(false);

  const sortingStatus = (rowA, rowB) => {
    const a = rowA.statusName;
    const b = rowB.statusName;

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  const sortingPeriod = (rowA, rowB) => {
    const a = rowA.periodName;
    const b = rowB.periodName;

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  // Creating columns
  const columns = [
    {
      name: "INVOICE NO.",
      selector: (row) => row.invoice_no,
      sortable: true,
      center: true,
    },
    {
      name: "PERIOD",
      selector: (row) => row.period,
      sortable: false,
      center: true,
      sortable: true,
      sortFunction: sortingPeriod,
      hide: "lg",
    },
    {
      name: "AMOUNT",
      selector: (row) => row.amount,
      sortable: true,
      center: true,
      hide: "lg",
    },
    {
      name: "STATUS",
      selector: (row) => row.status,
      sortable: true,
      // hide: "sm",
      center: true,
      sortFunction: sortingStatus,
    },
    {
      name: "ACTION",
      selector: (row) => row.action,
      center: true,
    },
  ];

  const getColor = (status) => {
    if (status === "PAYMENT PENDING") {
      return "bg-rose-200";
    } else if (status === "PAYMENT DONE") {
      return "bg-green-200";
    } else {
      return "bg-yellow-200";
    }
  };

  // Storinng table data value.
  useEffect(() => {
    if (result.length > 0) {
      const arr = [];
      result.map((item) => {
        const obj = {
          invoice_no: item.invoice_no,
          period: (
            <div title={item.period} className="truncate overflow-hidden">
              {item.period}
            </div>
          ),
          periodName: item.period,
          amount: item.amount,
          status: (
            <div
              title={item.status}
              className={`px-2 py-1 rounded-xl text-xs font-medium w-36 truncate overflow-hidden text-center ${getColor(
                item.status
              )}`}
            >
              {item.status.toLowerCase()}
            </div>
          ),
          statusName: item.status,
          action: (
            <div className="flex justify-between items-center space-x-2">
              <button className="btn-sm bg-[--bg-color-500] text-white p-2">
                <span className="fad fa-credit-card fill-current" />
              </button>
              <button className="btn-sm bg-[--bg-color-500] text-white p-2">
                <span className="fad fa-download fill-current" />
              </button>
            </div>
          ),
        };
        arr.push(obj);
      });
      setTableData(arr);
    }
  }, [result]);

  useEffect(() => {
    if (searchText && tableData) {
      const filterResult = tableData.filter(
        (item) =>
          (item.invoice_no &&
            item.invoice_no.toLowerCase().includes(searchText.toLowerCase())) ||
          (item.periodName &&
            item.periodName.toLowerCase().includes(searchText.toLowerCase())) ||
          (item.amount &&
            item.amount.toLowerCase().includes(searchText.toLowerCase())) ||
          (item.statusName &&
            item.statusName.toLowerCase().includes(searchText.toLowerCase()))
      );
      setFilterData(filterResult);
    } else {
      setFilterData();
    }
  }, [searchText]);

  // Internally, customStyles will deep merges your customStyles with the default styling.
  const customStyles = {
    headCells: {
      style: {
        fontFont: "24px",
        fontWeight: "bold",
        // backgroundColor:
      },
    },
  };

  // Removing rows per page
  const paginationComponentOptions = {
    noRowsPerPage: true,
  };

  // hide and show columns on desktop size
  const ExpandedComponent = ({ data }) => {
    return (
      <>
        <p className="px-4 mt-2 text-xs">
          <span className="font-semibold"> PERIOD :</span>{" "}
          {data.periodName}
        </p>
        <p className="px-4 mt-2 text-xs">
          <span className="font-semibold"> AMOUNT :</span>{" "}
          {data.amount}
        </p>
      </>
    );
  };

  const [width, setWidth] = useState(window.innerWidth);

  const windowResize = () => {
    // console.warn("resize event is called");
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", windowResize);
  }, [window.innerWidth]);

  return (
    <div className="mt-4 sm:mx-6 lg:mx-8">
      <div
        className="h-full flex flex-col bg-white md:flex-row"
        style={{ height: "100vh" }}
      >
        <Sidebar />
        <div className="flex-auto p-6">
          <div className="flex-auto space-y-2 md:space-y-0 md:flex md:justify-between md:item-center mb-2">
            <SearchForm
              placeholder="Search"
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
          <div className="overflow-x-auto shadow-md rounded border ">
            <DataTable
              columns={columns}
              data={filterData ? filterData : tableData}
              highlightOnHover
              progressPending={loader}
              responsive
              striped
              fixedHeader
              pagination
              paginationComponentOptions={paginationComponentOptions}
              customStyles={customStyles}
              expandableRows={width < 1281}
              expandableRowsComponent={ExpandedComponent}
              expandOnRowClicked={false}
              expandOnRowDoubleClicked={false}
              expandableRowsHideExpander={false}
              sortIcon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                  className="fill-current"
                  style={{ display: "block !important", color: '#94a3b8' }}
                >
                  <path d="M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z" />
                </svg>
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Invoice;

Invoice.auth = { path: "/invoice", role: "super-admin" };
